@if (corporateTaxEntity$ | async) {
<snelstart-ui-details [config]="detailsConfig" [entityId]="id" [title]="id">
  <snelstart-ui-details-buttons>
    <snelstart-ui-button [config]="saveButtonConfig" class="me-2" type="primary">Opslaan
    </snelstart-ui-button>
    @if (showButtonInfo(id)) {
      <snelstart-ui-button (click)="showDialogInfo()" type="secondary">Toelichting</snelstart-ui-button>
    }
  </snelstart-ui-details-buttons>

  <snelstart-ui-dialog-definition [(visible)]="dialogInfoVisible" id="specIB"
                                  size="lg"
                                  title="Toelichting bij '{{id}}'">
    <snelstart-ui-dialog-body>
      @if (id === 'Belastingplichtige') {
        <snelstart-venture-fiscaal-feature-tekst-belastingplichtige></snelstart-venture-fiscaal-feature-tekst-belastingplichtige>
      }
      @if (id === 'Administratie inlezen') {
        <snelstart-venture-fiscaal-feature-tekst-administratie-koppelen></snelstart-venture-fiscaal-feature-tekst-administratie-koppelen>
      }
      @if (id === 'Vragen vooraf') {
        <snelstart-venture-fiscaal-feature-tekst-vragen-vooraf></snelstart-venture-fiscaal-feature-tekst-vragen-vooraf>
      }
      @if (id === 'Samenstelling fiscale eenheid') {
        <snelstart-venture-fiscaal-feature-tekst-samenstelling-fiscale-eenheid></snelstart-venture-fiscaal-feature-tekst-samenstelling-fiscale-eenheid>
      }
      @if (id === 'Vragen fiscale eenheid') {
        <snelstart-venture-fiscaal-feature-tekst-vragen-fiscale-eenheid></snelstart-venture-fiscaal-feature-tekst-vragen-fiscale-eenheid>
      }
      @if (id === 'Balans activa') {
        <snelstart-venture-fiscaal-feature-tekst-balans-activa></snelstart-venture-fiscaal-feature-tekst-balans-activa>
      }
      @if (id === 'Balans passiva') {
        <snelstart-venture-fiscaal-feature-tekst-balans-passiva></snelstart-venture-fiscaal-feature-tekst-balans-passiva>
      }
      @if (id === 'Resultatenrekening') {
        <snelstart-venture-fiscaal-feature-tekst-resultatenrekening></snelstart-venture-fiscaal-feature-tekst-resultatenrekening>
      }
      @if (id === 'Vermogensvergelijking') {
        <snelstart-venture-fiscaal-feature-tekst-vermogensvergelijking></snelstart-venture-fiscaal-feature-tekst-vermogensvergelijking>
      }
      @if (id === 'Vrijgestelde winst') {
        <snelstart-venture-fiscaal-feature-tekst-vrijgestelde-winst></snelstart-venture-fiscaal-feature-tekst-vrijgestelde-winst>
      }
      @if (id === 'Beperkt aftrekbare kosten') {
        <snelstart-venture-fiscaal-feature-tekst-beperkt-aftrekbare-kosten></snelstart-venture-fiscaal-feature-tekst-beperkt-aftrekbare-kosten>
      }
      @if (id === 'Niet aftrekbare rente') {
        <snelstart-venture-fiscaal-feature-tekst-niet-aftrekbare-rente></snelstart-venture-fiscaal-feature-tekst-niet-aftrekbare-rente>
      }
      @if (id === 'Investeringsaftrek') {
        <snelstart-venture-fiscaal-feature-tekst-investeringsaftrek></snelstart-venture-fiscaal-feature-tekst-investeringsaftrek>
      }
      @if (id === 'Investeringen overig') {
        <snelstart-venture-fiscaal-feature-tekst-investeringen-overig></snelstart-venture-fiscaal-feature-tekst-investeringen-overig>
      }
      @if (id === 'Aftrekbare culturele giften') {
        <snelstart-venture-fiscaal-feature-tekst-culturele-giften></snelstart-venture-fiscaal-feature-tekst-culturele-giften>
      }
      @if (id === 'Aftrekbare overige giften') {
        <snelstart-venture-fiscaal-feature-tekst-gewone-giften></snelstart-venture-fiscaal-feature-tekst-gewone-giften>
      }
      @if (id === 'Verliesverrekening') {
        <snelstart-venture-fiscaal-feature-tekst-verliesverrekening></snelstart-venture-fiscaal-feature-tekst-verliesverrekening>
      }
      @if (id === 'Belastbaar bedrag') {
        <snelstart-venture-fiscaal-feature-tekst-belastbaarbedrag></snelstart-venture-fiscaal-feature-tekst-belastbaarbedrag>
      }
      @if (id === 'Belastingbedrag') {
        <snelstart-venture-fiscaal-feature-tekst-belastingbedrag></snelstart-venture-fiscaal-feature-tekst-belastingbedrag>
      }
      @if (id === 'Specificatie dividenduitkeringen') {
        <snelstart-venture-fiscaal-feature-tekst-spec-dividenduitkeringen></snelstart-venture-fiscaal-feature-tekst-spec-dividenduitkeringen>
      }
      @if (id === 'Specificatie aandeelhouders') {
        <snelstart-venture-fiscaal-feature-tekst-spec-aandeelhouders></snelstart-venture-fiscaal-feature-tekst-spec-aandeelhouders>
      }
      @if (id === 'Specificatie deelnemingen') {
        <snelstart-venture-fiscaal-feature-tekst-spec-deelnemingen></snelstart-venture-fiscaal-feature-tekst-spec-deelnemingen>
      }
    </snelstart-ui-dialog-body>

    <snelstart-ui-dialog-buttons class="d-flex mt-2">
      <snelstart-ui-button btn-x icon="check" id="saveVPBtotaal" type="primary">Afsluiten
      </snelstart-ui-button>
    </snelstart-ui-dialog-buttons>
  </snelstart-ui-dialog-definition>

  <snelstart-ui-details-content>
    @if (id === 'Belastingplichtige') {
      <snelstart-venture-fiscaal-feature-belastingplichtige></snelstart-venture-fiscaal-feature-belastingplichtige>
    }
    @if (id === 'Administratie inlezen') {
      <snelstart-venture-fiscaal-feature-administratie-koppelen></snelstart-venture-fiscaal-feature-administratie-koppelen>
    }
    @if (id === 'Vragen vooraf') {
      <snelstart-venture-fiscaal-feature-algemeen></snelstart-venture-fiscaal-feature-algemeen>
    }
    @if (id === 'Vragen fiscale eenheid') {
      <snelstart-venture-fiscaal-feature-vragen-fiscale-eenheid></snelstart-venture-fiscaal-feature-vragen-fiscale-eenheid>
    }
    @if (id === 'Samenstelling fiscale eenheid') {
      <snelstart-venture-fiscaal-feature-fiscale-eenheid-samenstelling></snelstart-venture-fiscaal-feature-fiscale-eenheid-samenstelling>
    }
    @if (id === 'Balans activa') {
      <snelstart-venture-fiscaal-feature-balans-activa></snelstart-venture-fiscaal-feature-balans-activa>
    }
    @if (id === 'Balans passiva') {
      <snelstart-venture-fiscaal-feature-balans-passiva></snelstart-venture-fiscaal-feature-balans-passiva>
    }
    @if (id === 'Resultatenrekening') {
      <snelstart-venture-fiscaal-feature-resultaten-rekening></snelstart-venture-fiscaal-feature-resultaten-rekening>
    }
    @if (id === 'Vermogensvergelijking') {
      <snelstart-venture-fiscaal-feature-vermogens-vergelijking></snelstart-venture-fiscaal-feature-vermogens-vergelijking>
    }
    @if (id === 'Investeringsaftrek') {
      <snelstart-venture-fiscaal-feature-investeringen></snelstart-venture-fiscaal-feature-investeringen>
    }
    @if (id === 'Investeringen overig') {
      <snelstart-venture-fiscaal-feature-spec-correcties-bijzonderheden></snelstart-venture-fiscaal-feature-spec-correcties-bijzonderheden>
    }
    @if (id === 'Vrijgestelde winst') {
      <snelstart-venture-fiscaal-feature-vrijgestelde-winst></snelstart-venture-fiscaal-feature-vrijgestelde-winst>
    }
    @if (id === 'Beperkt aftrekbare kosten') {
      <snelstart-venture-fiscaal-feature-beperkt-aftrekbare-kosten></snelstart-venture-fiscaal-feature-beperkt-aftrekbare-kosten>
    }
    @if (id === 'Niet aftrekbare boetes') {
      <snelstart-venture-fiscaal-feature-niet-aftrekbare-boetes></snelstart-venture-fiscaal-feature-niet-aftrekbare-boetes>
    }
    @if (id === 'Niet aftrekbare rente') {
      <snelstart-venture-fiscaal-feature-niet-aftrekbare-rente></snelstart-venture-fiscaal-feature-niet-aftrekbare-rente>
    }
    @if (id === 'Aftrekbare culturele giften') {
      <snelstart-venture-fiscaal-feature-aftrekbare-giften></snelstart-venture-fiscaal-feature-aftrekbare-giften>
    }
    @if (id === 'Aftrekbare overige giften') {
      <snelstart-venture-fiscaal-feature-overige-giften></snelstart-venture-fiscaal-feature-overige-giften>
    }
    @if (id === 'Verliesverrekening') {
      <snelstart-venture-fiscaal-feature-verliezen></snelstart-venture-fiscaal-feature-verliezen>
    }
    @if (id === 'Belastbaar bedrag') {
      <snelstart-venture-fiscaal-feature-overzicht></snelstart-venture-fiscaal-feature-overzicht>
    }
    @if (id === 'Belastingbedrag') {
      <snelstart-venture-fiscaal-feature-belasting-bedrag></snelstart-venture-fiscaal-feature-belasting-bedrag>
    }
    @if (id === 'Specificatie dividenduitkeringen') {
      <snelstart-venture-fiscaal-feature-dividends></snelstart-venture-fiscaal-feature-dividends>
    }
    @if (id === 'Specificatie aandeelhouders') {
      <snelstart-venture-fiscaal-feature-aandeelhouders></snelstart-venture-fiscaal-feature-aandeelhouders>
    }
    @if (id === 'Specificatie deelnemingen') {
      <snelstart-venture-fiscaal-feature-deelnemingen></snelstart-venture-fiscaal-feature-deelnemingen>
    }
    @if (id === 'Specificatie willekeurige afschrijvingen') {
      <snelstart-venture-fiscaal-feature-willekeurig-afschrijven></snelstart-venture-fiscaal-feature-willekeurig-afschrijven>
    }
    @if (id === 'Specificatie agrarische activiteiten') {
      <snelstart-venture-fiscaal-feature-spec-agrarisch></snelstart-venture-fiscaal-feature-spec-agrarisch>
    }
    @if (id === 'Specificatie innovatiebox') {
      <snelstart-venture-fiscaal-feature-innovatiebox></snelstart-venture-fiscaal-feature-innovatiebox>
    }
    @if (id === 'Specificatie functionele valuta') {
      <snelstart-venture-fiscaal-feature-functionele-valuta></snelstart-venture-fiscaal-feature-functionele-valuta>
    }
    @if (id === 'Specificatie voeging') {
      <snelstart-venture-fiscaal-feature-fiscale-eenheid-voeging></snelstart-venture-fiscaal-feature-fiscale-eenheid-voeging>
    }
    @if (id === 'Specificatie ontvoeging') {
      <snelstart-venture-fiscaal-feature-fiscale-eenheid-ontvoeging></snelstart-venture-fiscaal-feature-fiscale-eenheid-ontvoeging>
    }
    @if (id === 'Specificatie ontbinding') {
      <snelstart-venture-fiscaal-feature-fiscale-eenheid-ontbinding></snelstart-venture-fiscaal-feature-fiscale-eenheid-ontbinding>
    }
    @if (id === 'Specificatie verliezen') {
      <snelstart-venture-fiscaal-feature-fiscale-eenheid-verliezen></snelstart-venture-fiscaal-feature-fiscale-eenheid-verliezen>
    }
    @if (id === 'Specificatie bronheffingen') {
      <snelstart-venture-fiscaal-feature-bronheffing></snelstart-venture-fiscaal-feature-bronheffing>
    }
    @if (id === 'Openingsbalansen activa') {
      <snelstart-venture-fiscaal-feature-spec-open-activa></snelstart-venture-fiscaal-feature-spec-open-activa>
    }
    @if (id === 'Openingsbalansen passiva') {
      <snelstart-venture-fiscaal-feature-spec-open-passiva></snelstart-venture-fiscaal-feature-spec-open-passiva>
    }
    @if (id === 'Slotbalansen activa') {
      <snelstart-venture-fiscaal-feature-spec-slot-activa></snelstart-venture-fiscaal-feature-spec-slot-activa>
    }
    @if (id === 'Slotbalansen passiva') {
      <snelstart-venture-fiscaal-feature-spec-slot-passiva></snelstart-venture-fiscaal-feature-spec-slot-passiva>
    }
    @if (id === 'Resultatenrekeningen') {
      <snelstart-venture-fiscaal-feature-enkelvoudige-cijfers></snelstart-venture-fiscaal-feature-enkelvoudige-cijfers>
    }
    @if (id === 'Specificatie omzetbelasting') {
      <snelstart-venture-fiscaal-feature-spec-omzetbelasting></snelstart-venture-fiscaal-feature-spec-omzetbelasting>
    }
    @if (id === 'Specificatie herinvesteringsreserve') {
      <snelstart-venture-fiscaal-feature-spec-hir></snelstart-venture-fiscaal-feature-spec-hir>
    }
  </snelstart-ui-details-content>

</snelstart-ui-details>
}
